import { DEFAULT_TIME_ZONE } from '../constants';
import {
  RecurringEventValue,
  ScheduleDateOrRelative,
  ScheduleReference,
  ScheduledEventValue,
} from '../types';

/** `startsAt` is preserved when switching from `recurring` to `scheduled` (shared start date). */
export function createDefaultScheduledValue(
  timeZone: string = DEFAULT_TIME_ZONE,
  executeAt: ScheduleDateOrRelative = { reference: 'now' },
): ScheduledEventValue {
  return {
    type: 'scheduled',
    timeZone,
    executeAt,
  };
}

/** `startsAt`/`expression` are preserved when switching from `scheduled` to `recurring` (shared start date). */
export function createDefaultRecurringValue(
  timeZone: string = DEFAULT_TIME_ZONE,
  startsAt: ScheduleDateOrRelative = { reference: 'now' },
  expression = '0 9 ? * MON-FRI *',
  reference: ScheduleReference = 'now',
): RecurringEventValue {
  return {
    type: 'recurring',
    timeZone,
    startsAt,
    endsAt: { reference, increments: [{ value: 1, unit: 'months' }] },
    recurrence: {
      type: 'cron',
      expression,
    },
  };
}
